export default __webpack_public_path__ + "static/182-0b49ca5427748eafa1b576a006ea4b46.jpg";